import { Card, CardBody, Textarea } from '@heroui/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function Text({ answerHistory, sendAnswer }) {
  const { t } = useTranslation('survey');

  const [answer, setAnswer] = useState('');
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (answerHistory) {
      sendAnswer(answerHistory);
      setAnswer(answerHistory);
    } else {
      sendAnswer('');
    }
  }, []);

  useEffect(() => {
    if (answerHistory && answerHistory.length > 0) {
      setCount(answerHistory.length);
    }
  }, []);

  const handleChange = (event) => {
    const count = event.target.value.length;
    if (count > 1000) return;

    setCount(count);
    setAnswer(event.target.value);
    sendAnswer(event.target.value);
  };

  return (
    <Card>
      <CardBody>
        <Textarea
          defaultValue={answerHistory}
          value={answer}
          minRows={3}
          placeholder={t('common.input.text_placeholder')}
          onChange={(e) => handleChange(e)}
        />
        <p className="font-light text-sm pt-2">
          {t('text.character_limit', { count })}
        </p>
      </CardBody>
    </Card>
  );
}
